module.exports = __webpack_public_path__ + "static/media/gallery30.0aecbe53.png";